import { cm2px } from '~src/utils/units';

export const mm2px = (mm, dpi) => {
  const cm = mm / 10;
  return cm2px(cm, dpi);
};
